export default __webpack_public_path__ + "media/zurb/img/home/home-contact-bg-ec779de058603b39746e46aa3080431c.png";